import { DEFAULT_ACCENT_COLOR } from '@cibli/shared';
import { z } from 'zod';

/**
 * JSON Resume theme params — unified with native templates.
 * - accentColor: uses the same DEFAULT_ACCENT_COLOR as native templates
 * - spacing: 'compact' | 'normal' | 'aere' (same values as native templates)
 */
export const jsonResumeSchema = z.object({
  accentColor: z.string().default(DEFAULT_ACCENT_COLOR),
  spacing: z.enum(['compact', 'normal', 'aere']).default('normal'),
});

export type JsonResumeParams = z.infer<typeof jsonResumeSchema>;

export const jsonResumeDefaults: JsonResumeParams = {
  accentColor: DEFAULT_ACCENT_COLOR,
  spacing: 'normal',
};
